import { useRef } from 'react'
import { Message } from 'rsuite'
import useStandardToaster from '../../../ui_reusable/StandardToaster'
import CreatorAccordion from '../../../ui_reusable/CreatorAccordion'
import UserForm from './user_form/UserForm'

const CreateUser = ({ clientId, setRefresh }) => {
  const { pushToast } = useStandardToaster()
  const panelRef = useRef(null)

  // Function to grant project access to manager users
  const grantProjectAccessToManager = async (userId, clientUserId) => {
    try {
      // First fetch all projects for the client
      const projectsResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v2/projects/?client=${clientId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        },
      )

      const projectsData = await projectsResponse.json()
      const projects = projectsData.data

      // Grant access to each project
      for (const project of projects) {
        await fetch(
          `${process.env.REACT_APP_API_URL}/api/projects/${project.id}/users/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
              client_user_id: clientUserId,
            }),
          },
        )
      }

      pushToast(
        <Message type="success">
          Project access granted for all client projects
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
    } catch (error) {
      console.error('Failed to grant project access:', error)
      pushToast(
        <Message type="error">
          Failed to grant project access to all projects
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
    }
  }

  const handleSubmit = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/clients/${clientId}/users/`,
        {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            user: {
              name: formData.name,
              email: formData.email,
              phone: formData.phone,
            },
            role: formData.role,
          }),
        },
      )

      const responseData = await response.json()

      if (response.status !== 201) {
        throw new Error(responseData.message || 'Failed to create user')
      }

      // If the user is a manager, automatically grant access to all projects
      if (formData.role === 'manager') {
        await grantProjectAccessToManager(
          responseData.data.user.id,
          responseData.data.id, // client_user_id from response
        )
      }

      await setRefresh(Date.now())

      return true
    } catch (error) {
      // Instead of using toaster, throw the error to be handled by the form
      throw error
    }
  }

  const handleSuccess = () => {
    if (panelRef.current) {
      panelRef.current.tryCollapse()
    }
  }

  return (
    <CreatorAccordion id={'createUserAccordion'}>
      <CreatorAccordion.Panel ref={panelRef} header="Add new user">
        <UserForm
          onSubmit={handleSubmit}
          submitButtonText="Create User"
          successMessage="User created successfully!"
          onSuccess={handleSuccess}
          resetOnSuccess={true}
        />
      </CreatorAccordion.Panel>
    </CreatorAccordion>
  )
}

export default CreateUser
